import {
  FETCH_BLOGS_REQUEST,
  FETCH_BLOGS_SUCCESS,
  FETCH_BLOGS_FAILURE,
  UPDATE_BLOGS,
} from "./actionTypes";
import { getBlogs } from "../../apiCalls/urls/urlFunction";
import { sortByKey } from "../../hooks/utilsFn/utilsFn";

export function onFetchBlogs() {
  return async (dispatch) => {
    dispatch({ type: FETCH_BLOGS_REQUEST });

    try {
      const { data, status } = await getBlogs();

      if (status && Array.isArray(data?.data)) {
        const sortedData = sortByKey(data?.data, "id", 'desc');
        dispatch({
          type: FETCH_BLOGS_SUCCESS,
          payload: sortedData,
        });

        // Optional: still call UPDATE_BLOGS for legacy support
        dispatch(updateBlogsReducer(sortedData));
      } else {
        throw new Error(data?.error || "Failed to fetch blogs");
      }
    } catch (error) {
      console.error(error.message);
      dispatch({
        type: FETCH_BLOGS_FAILURE,
        payload: error.message,
      });
    }
  };
}

export const updateBlogsReducer = (payload) => ({
  type: UPDATE_BLOGS,
  payload,
});
